import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  MenuItem,
  Select,
  Box,
  Grid,
  Tooltip,
} from "@mui/material";
import { AddBox } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { brandingSettings } from "../branding";

interface ProvisionRowProps {
  item: {
    user_id: string;
    user_email: string;
    type: string;
    request: string;
  };
  updateUserRole: (userId: string, userEmail: string, newRole: string) => void;
}

const ProvisionRow: React.FC<ProvisionRowProps> = ({ item, updateUserRole }) => {
  const [role, setRole] = useState(item.type === "none" ? "user" : item.type);
  const [roleChanged, setRoleChanged] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const theme = useTheme();

  const handleRoleChange = (newRole: string) => {
    setRole(newRole);
    setRoleChanged(item.type !== newRole);
  };

  const handleUpdateRole = async () => {
    setRoleLoading(true);
    try {
      await updateUserRole(item.user_id, item.user_email, role);
      setRoleChanged(false);
    } finally {
      setRoleLoading(false);
    }
  };

  const updateStatus = async () => {
    setRoleLoading(true);
    try {
      await updateUserRole(item.user_id, item.user_email, "user");
      setRoleChanged(false);
    } finally {
      setRoleLoading(false);
    }
  };

  return (
  <Grid container alignItems="center" spacing={1}>
    <Grid item>
      <Select
        id={`role-${item.user_id}`}
        size="small"
        value={role}
        onChange={(e) => handleRoleChange(e.target.value as string)}
        sx={{ width: "120px" }}
        displayEmpty
      >
        <MenuItem value="" disabled>Change role</MenuItem>
        <MenuItem value="user" sx={{
          color: theme.palette.mode === "dark" ? brandingSettings.textcolorSecondaryDark : "inherit",
        }}>User</MenuItem>
        <MenuItem value="admin" sx={{
          color: theme.palette.mode === "dark" ? brandingSettings.textcolorSecondaryDark : "inherit",
        }}>Admin</MenuItem>
        <MenuItem value="remove" sx={{
          color: theme.palette.mode === "dark" ? brandingSettings.textcolorSecondaryDark : "inherit",
        }}>Remove</MenuItem>
      </Select>
    </Grid>
      
      {roleChanged && (
      <Grid item>
        {roleLoading ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          <Button
            color="success"
            variant="contained"
            size="small"
            onClick={handleUpdateRole}
          >
            Update
          </Button>
        )}
      </Grid>
      )}
      
      {item.request === "pending" && (
        <Grid item>
          <Tooltip title="Accept user">
            <Button
              data-testid="accept-user"
              id="accept"
              size="small"
              color="success"
              sx={{ fontSize: "12px", py: 1 }}
              onClick={updateStatus}
            >
              <AddBox />
            </Button>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};

export default ProvisionRow;
